import { Injectable } from '@angular/core';
import { CacheData } from 'functions/src/models/cache-data';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  public static readonly CACHE_FOREVER_DURATION: number = -1;
  public static readonly CACHE_DEFAULT_DURATION: number = 3600000;
  private _storage: Storage;

  constructor() {
    this._storage = window.localStorage;
  }

  public set<T>(
    key: string,
    value: T,
    desiredExpiration: number = CacheService.CACHE_DEFAULT_DURATION
  ): void {
    let expiration: number | undefined;
    if (desiredExpiration !== CacheService.CACHE_FOREVER_DURATION) {
      expiration = Date.now() + desiredExpiration;
    }

    const entry: CacheData<T> = {
      expiration,
      value,
    };

    this._storage.setItem(key, JSON.stringify(entry));
  }

  public get<T>(key: string): T | undefined {
    let result: CacheData<T>;

    const json: string | null = this._storage.getItem(key);

    if (json === null) {
      return undefined;
    }

    result = JSON.parse(json) as CacheData<T>;

    if (result) {
      if (result.expiration === undefined || result.expiration > Date.now()) {
        return result.value;
      }
      this._storage.removeItem(key);
    }

    return undefined;
  }

  public remove(key: string): void {
    this._storage.removeItem(key);
  }

  public clear(): void {
    this._storage.clear();
  }
}
